import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class ApiClientInterceptor implements HttpInterceptor {

    constructor() {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const token = sessionStorage.getItem("token");
      if (token != null) {
        const clone = req.clone(
          {
            setHeaders: {
              Authorization: `ExternalJwt ${token}`
            }
          }
        );
        return next.handle(clone);
      }

      return next.handle(req);
    }
}
